import servicetTableroIndicador from '@/services/GsEncuesta/tableroIndicador'

export default {
  TABLERO_INDICADOR_REPORT_1(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findIndicador1(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TABLERO_INDICADOR_REPORT_2(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findIndicador2(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TABLERO_INDICADOR_REPORT_FICHA(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findIndicadorFicha(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
